/// <amd-module name="TFS/Authorization/Error/Components/RequestAccessComponent" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "VSSUI/Button";
import { Dialog } from "VSSUI/Dialog";
import { ObservableValue } from "VSS/Core/Observable";
import * as Utils_String from "VSS/Core/Util/String";
import { readJsonScript } from "VSS/Platform/Util/Serialization";
import { TextField, TextFieldWidth } from "VSSUI/TextField";
import { Link } from "VSSUI/Link";

import * as AuthorizationErrorResources from "TFS/Authorization/Error/Resources";

export interface IRequestAccessComponentState {
    requestAccess: boolean;
    accessRequested: boolean;
    requestFailed: boolean;
    message: ObservableValue<string>;
}

interface IAuthData {
    requestAccessEndpoint: string;
    emailAddress: string;
    organizationName: string;
    userSessionToken: string;
    urlRequested: string;
    projectUri: string;    
    isPolicyEnabled: boolean;
    requestAccessUrl: string;
}

export default class RequestAccessComponent extends React.Component<{}, IRequestAccessComponentState> {
    private actionData: IAuthData | null;

    constructor(props: {}) {
        super(props);

        const dataDictionary = readJsonScript<{ [key: string]: any }>("action-data");
        this.actionData = dataDictionary && dataDictionary["AuthExceptionData"];
        this.state = { requestAccess: false, accessRequested: false, requestFailed: false, message: new ObservableValue<string>("") };
    }

    public render() {
        if (!this.actionData) {
            return;
        }

        return (
            <>
                {this.actionData.isPolicyEnabled ? (
                    <div>
                        {this.state.accessRequested ? (
                             <Button disabled={true}>{AuthorizationErrorResources.AccessRequestedText}</Button>
                        ) : (
                            <Button
                                primary={true}
                                onClick={() => {
                                    this.setState({ requestAccess: true });
                                }}
                            >
                            {AuthorizationErrorResources.RequestButtonText}
                            </Button>
                        )}
                    </div>
                ) : (
                    <div className="request-access-disabled">
                        <Button disabled={true}>{AuthorizationErrorResources.RequestButtonText}</Button>                        
                        <span className="request-access-disabled-dialog">
                            <span className="request-access-disabled-message">
                                {AuthorizationErrorResources.RequestAccessUrlDescription}
                            </span>
                            <Link
                                className="request-access-disabled-url"
                                href={this.actionData.requestAccessUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={AuthorizationErrorResources.RequestAccessDescriptionAriaLabel}
                            >
                            {AuthorizationErrorResources.RequestAccessUrlLinkDescription}
                            </Link>
                        </span>
                    </div>
                )}

                {this.state.requestAccess ? (
                    <Dialog
                        calloutContentClassName="request-access-feedback-dialog"
                        footerButtonProps={[
                            {
                                onClick: () => {
                                    this.closeDialog(false);
                                },
                                text: AuthorizationErrorResources.CancelButtonText
                            },
                            {
                                primary: true,
                                onClick: () => {
                                    this.closeDialog(true);
                                },
                                text: AuthorizationErrorResources.SendButtonText
                            }
                        ]}
                        lightDismiss={false}
                        onDismiss={() => {
                            this.closeDialog(false);
                        }}
                        titleProps={{ text: AuthorizationErrorResources.RequestAccessDialogTitle }}
                    >
                        <span className="access-message">
                            {Utils_String.format(
                                AuthorizationErrorResources.AccessMessage,
                                this.actionData.emailAddress,
                                this.actionData.organizationName
                            )}
                        </span>
                        <span className="access-optional-note">{AuthorizationErrorResources.AccessMessageOptional}</span>
                        <TextField
                            ariaLabel={AuthorizationErrorResources.RequestAccessAriaLabel}
                            multiline
                            rows={4}
                            width={TextFieldWidth.auto}
                            value={this.state.message}
                            onChange={(e, newValue) => (this.state.message.value = newValue)}
                            maxLength={200}
                        />
                        <span className="access-info-message">{AuthorizationErrorResources.EmailAdministrators}</span>
                        {this.state.requestFailed ? <span className="access-error-message">{AuthorizationErrorResources.RequestFailed}</span> : null}
                    </Dialog>
                ) : null}
            </>
        );
    }

    private closeDialog(accessRequested: boolean) {
        this.setState({
            requestAccess: false,
            requestFailed: false
        });

        if (accessRequested) {
            if (this.actionData) {
                fetch(this.actionData.requestAccessEndpoint, {
                    method: "post",
                    body: JSON.stringify({
                        Message: this.state.message.value,
                        UrlRequested: this.actionData.urlRequested,
                        ProjectUri: this.actionData.projectUri
                    }),
                    headers: {
                        Accept: "application/json; api-version=5.1-preview.1",
                        "Content-Type": "application/json; charset=utf-8; api-version=5.1-preview.1",
                        Authorization: "Bearer " + this.actionData.userSessionToken
                    }
                })
                    .then(response => {
                        if (response.ok) {
                            this.setState({
                                requestAccess: false,
                                accessRequested: true
                            });
                            return;
                        }
                        throw new Error("Email Request Failed");
                    })
                    .catch(error => {
                        console.error(error.message);
                        this.setState({
                            requestAccess: true,
                            requestFailed: true
                        });
                    });
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    ReactDOM.render(<RequestAccessComponent />, document.getElementById("primary-action"));
});
